//define an array of svgIcon & svgUrl
export class SvgIcon {
  name: string
  url: string
  constructor(name: string, url: string) {
    this.name = name
    this.url = url
  }
}
